import { Key, TableRowSelection } from 'antd/es/table/interface'
import { useState } from 'react'

import { Record } from './use-employee-columns'

export default function useBatchOperations() {
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([])

  const rowSelection: TableRowSelection<Record> = {
    selectedRowKeys,
    onChange: (nextSelectedRowKeys: Key[]) => {
      const convertedKeys = nextSelectedRowKeys.map((key) => (
        typeof key === 'number' ? key : Number(key)
      ))
      setSelectedRowKeys(convertedKeys)
    },
  }

  return { rowSelection, selectedRowKeys }
}
